import { getLogger } from '../logging/logger';

const CN = 'FetchUtil';
const logger = getLogger(CN);

export default function fetchData(url, requestData) {
	logger.log(`[fetchData]`, { url, requestData });

	return new Promise((resolve, reject) => {
		const worker = new Worker(new URL('fetch.worker.js', import.meta.url));
		worker.onmessage = (event) => {
			logger.debug(`[onResponseMessage]`, { event });

			const { error, ...responseData } = event.data;
			if (error) {
				reject(new Error(error));
			} else {
				resolve(responseData);
			}

			worker.terminate();
		};
		worker.onerror = (error) => logger.error(`[${CN}][Worker Error]`, error);

		worker.postMessage({
			url,
			...requestData,
		});
	});
}
